import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PermissionGuard from "components/PermissionGuard";

const UserTableRow = ({
  user,
  index,
  onLogoutUser,
  onEnableDisable,
  userLogout,
}) => {
  const { t } = useTranslation();

  const isPilot = user?.roles?.some(
    (r) =>
      (r.name === "pilot-filial" || r.name === "pilot-holding") &&
      user.identite?.staff?.is_active_pilot
  );

  const formatRoles = (roles) => {
    if (!roles || !roles.length) return "";
    return roles.map((r) => r.name).join(" / ");
  };

  return (
    <tr key={user.id} role="row" className={index % 2 === 0 ? "even" : "odd"}>
      <td>
        {`${user.identite?.lastname || ""} ${user.identite?.firstname || ""} `}
        {isPilot && (
          <span className="kt-badge kt-badge--success kt-badge--inline">
            {t("pilot actif")}
          </span>
        )}
      </td>
      <td>{user.username || user.email}</td>
      <td>{formatRoles(user.roles)}</td>
      <td>
        <span
          className={`kt-badge kt-badge--${
            user.disabled_at === null ? "success" : "danger"
          } kt-badge--inline kt-badge--pill`}
        >
          {user.disabled_at === null ? t("Actif") : t("Inactif")}
        </span>
      </td>
      <td className="d-flex justify-content-between align-items-center">
        <div
          id={`user-spinner-${user.id}`}
          className="kt-spinner kt-spinner--lg kt-spinner--dark mt-2 mx-3"
          style={{ display: "none" }}
        />

        <a
          className="mt-2"
          id={`user-${user.id}`}
          href={
            user.disabled_at === null
              ? `desactive/${user.id}`
              : `reactive/${user.id}`
          }
          onClick={(e) =>
            onEnableDisable(
              e,
              user.id,
              index,
              user.disabled_at === null ? t("Désactiver") : t("Activer")
            )
          }
          title={user.disabled_at === null ? t("Désactiver") : t("Activer")}
        >
          {user.disabled_at === null ? t("Désactiver") : t("Activer")}
        </a>

        <PermissionGuard
          permissions={[
            "show-user-any-institution",
            "show-user-my-institution",
          ]}
        >
          <Link
            to={`/settings/users/${user.id}/edit`}
            id={`user-edit-${user.id}`}
            className="btn btn-sm btn-clean btn-icon btn-icon-md"
            title={t("Modifier")}
          >
            <i className="la la-edit" />
          </Link>
        </PermissionGuard>

        <PermissionGuard permissions={["logout-user-my-institution"]}>
          <button
            onClick={onLogoutUser}
            className="btn btn-sm btn-clean btn-icon btn-icon-md"
            title={t("Déconnecter")}
            disabled={userLogout}
          >
            <i
              className="la la-sign-out"
              style={{ color: userLogout ? "red" : "green" }}
            />
          </button>
        </PermissionGuard>
      </td>
    </tr>
  );
};

export default UserTableRow;
